/* eslint-disable import/no-anonymous-default-export */
import { deploymentTypes, servers, serverType } from "../deployment-config";

// let host = window.location.hostname;
export default {
    // baseURL: 'https://kiran-svcln.pantheonsite.io/rest',
    // baseURL: host==='localhost'?'http://localhost:5002':'https://'+host,
    // baseURL: host==='localhost'?'http://localhost:8085':'http://192.9.243.242:8085',

    // baseURL: 'http://192.9.243.242:8085',
    baseURL: serverType === deploymentTypes.development?'https://'+servers.development:'https://'+servers.production,


    // timeout: 1000,
    headers: {
    'Content-Type': 'application/json',
    // 'Referer': 'https://kiran-svcln.pantheonsite.io',
    // 'Origin':'https://kiran-svcln.pantheonsite.io'
},
    // withCredentials: true
};